

















import Vue from 'vue';
import {
  Component, Emit, Prop, Watch, Provide,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Mutation, State } from 'vuex-class';
import {
  KPortalHeader, KAppToolbar, KAppToolbarBtn, KNoticeContainer, KNavigationDrawer, KSelectFi,
}
  from '@kasasa/fbase-components';
import {
  MenuItem, MenuHeading, Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import { ProductResource, ProductValidationResult }
  from '@/api/product/';
import { AuditMessageResource }
  from '@/api/auditmessages/';
import { InterestSettingsResource }
  from '@/api/interestSettings/';
import { ReportResource, Report }
  from '@/api/reports';
import { CycleResource, Cycle }
  from '@/api/cycles';
import menuDefinitions from '@/menu';
import {
  EocEmailConfigResource, EocEmailEventResource, EocEmailMetricsResource, SendEocEmailResource,
}
  from '@/api/eocemailsettings/';
import { ATMSettingsResource }
  from '@/api/atmsettings/';
import { ProcessingDaysResource, HolidayResource }
  from '@/api/processingdays/';
import { StatementCodeMappingResource, StatmentCodeMappingRuleResource }
  from '@/api/statementcodes/';
import { AccountTypeMappingResource, AccountTypeMappingRuleResource }
  from '@/api/accounttypes/';
import { RelationshipClassificationResource, RelationshipClassificationRuleResource }
  from '@/api/relationshipclassification/';
import { TransactionClassificationResource, TransactionClassificationRuleResource, TransactionClassificationIncludesRepository }
  from '@/api/transactionclassification/';
import { ClosedAccountSettingsResource, DormantAccountSettingsResource, OpenedAccountSettingsResource }
  from '@/api/accountstatussettings/';
import {
  LoanAccountSettingsResource, DelinquentSettingsResource, MaturedSettingsResource, NonAccrualSettingsResource, WrittenOffSettingsResource,
}
  from '@/api/loanaccountstatussettings/';
import { ConfigVersionResource, ConfigVersion }
  from '@/api/configversion/';
import { FiConfigurationResource }
  from '@/api/ficonfiguration/';
import { ProductMappingResource }
  from '@/api/productmapping';
import { ProductTypesResource }
  from '@/api/producttypes';
import { AccountProductTypesResource }
  from '@/api/accountproducttypes';
import { EngagementRewardResource }
  from '@/api/engagementrewards';
import { KasasaUpgradeResource }
  from '@/api/kasasaupgrade';


@Component({
  components: {
    KPortalHeader,
    KNavigationDrawer,
    KNoticeContainer,
    KAppToolbar,
    KSelectFi,
  },
  computed: mapState([
    'auth',
    'fiId',
    'configVersion',
    'productMappingErrorMessage',
    'allConfigVersions',
  ]),
})
export default class App extends Vue {
  appTitle: string = 'Rewards Configurations';

  fiId!: string;

  auth!: AuthStore;

  configVersion!: ConfigVersion;

  allConfigVersions!: ConfigVersion[];

  @Prop({
    type: Array,
    default() {
      return [...menuDefinitions];
    },
  }) initialMenuItems!: (MenuItem | MenuHeading)[];

  currentMenuItems: (MenuItem | MenuHeading)[] = [];

  @Emit('error')
  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  @Mutation('fiId') mutationFi: any;

  @Mutation('configVersion') mutationConfigVersion: any;

  @Mutation('productMappingErrorMessage') mutationProductMappingErrorMessage: any;

  @Mutation('productValidationResults') mutationProductValidationResults: any;

  @Mutation('allConfigVersions') mutationAllConfigVersions: any;

  productMappingErrorMessage!:string | null;

  @Provide('ProductResource')
  private productResource: ProductResource =
    new ProductResource(this.$store);

  @Provide('EocEmailEventResource')
  private eocEmailEventResource: EocEmailEventResource =
    new EocEmailEventResource(this.$store);

  @Provide('EocEmailMetricsResource')
  private eocEmailMetricsResource: EocEmailMetricsResource =
    new EocEmailMetricsResource(this.$store);

  @Provide('EocEmailConfigResource')
  private eocEmailConfigResource: EocEmailConfigResource =
    new EocEmailConfigResource(this.$store);

  @Provide('SendEocEmailResource')
  private sendEocEmailResource: SendEocEmailResource =
    new SendEocEmailResource(this.$store);

  @Provide('AuditMessageResource')
  private auditMessageResource: AuditMessageResource =
    new AuditMessageResource(this.$store);

  @Provide('ATMSettingsResource')
  private atmSettingsResource: ATMSettingsResource =
    new ATMSettingsResource(this.$store);

  @Provide('InterestSettingsResource')
  private interestSettingsResource: InterestSettingsResource =
    new InterestSettingsResource(this.$store);

  @Provide('HolidayResource')
  private holidayResource: HolidayResource =
    new HolidayResource(this.$store);

  @Provide('ProcessingDaysResource')
  private processingDaysResource: ProcessingDaysResource =
    new ProcessingDaysResource(this.$store);

  @Provide('StatementCodeMappingResource')
  private statementCodeMappingResource: StatementCodeMappingResource =
    new StatementCodeMappingResource(this.$store);

  @Provide('StatmentCodeMappingRuleResource')
  private statmentCodeMappingRuleResource: StatmentCodeMappingRuleResource =
    new StatmentCodeMappingRuleResource(this.$store);

  @Provide('AccountTypeMappingResource')
  private accountTypeMappingResource: AccountTypeMappingResource =
    new AccountTypeMappingResource(this.$store);

  @Provide('AccountTypeMappingRuleResource')
  private accountTypeMappingRuleResource: AccountTypeMappingRuleResource =
    new AccountTypeMappingRuleResource(this.$store);

  @Provide('RelationshipClassificationResource')
  private relationshipClassificationResource: RelationshipClassificationResource =
    new RelationshipClassificationResource(this.$store);

  @Provide('RelationshipClassificationRuleResource')
  private relationshipClassificationRuleResource: RelationshipClassificationRuleResource =
    new RelationshipClassificationRuleResource(this.$store);

  @Provide('TransactionClassificationResource')
  private transactionClassificationResource: TransactionClassificationResource =
    new TransactionClassificationResource(this.$store);

  @Provide('TransactionClassificationRuleResource')
  private transactionClassificationRuleResource: TransactionClassificationRuleResource =
    new TransactionClassificationRuleResource(this.$store);

  @Provide('TransactionClassificationIncludesRepository')
  private transactionClassificationIncludesRepository: TransactionClassificationIncludesRepository =
    new TransactionClassificationIncludesRepository();

  @Provide('ConfigVersionResource')
  private configVersionResource: ConfigVersionResource =
    new ConfigVersionResource(this.$store);

  @Provide('ClosedAccountSettingsResource')
  private closedAccountResource: ClosedAccountSettingsResource =
    new ClosedAccountSettingsResource(this.$store);

  @Provide('OpenedAccountSettingsResource')
  private openedAccountResource: OpenedAccountSettingsResource =
    new OpenedAccountSettingsResource(this.$store);

  @Provide('DormantAccountSettingsResource')
  private dormantAccountResource: DormantAccountSettingsResource =
    new DormantAccountSettingsResource(this.$store);

  @Provide('LoanAccountSettingsResource')
  private loanAccountResource: LoanAccountSettingsResource =
    new LoanAccountSettingsResource(this.$store);

  @Provide('DelinquentSettingsResource')
  private delinquentSettingsResource: DelinquentSettingsResource =
    new DelinquentSettingsResource(this.$store);

  @Provide('MaturedSettingsResource')
  private maturedSettingsResource: MaturedSettingsResource =
    new MaturedSettingsResource(this.$store);

  @Provide('NonAccrualSettingsResource')
  private nonAccrualSettingsResource: NonAccrualSettingsResource =
    new NonAccrualSettingsResource(this.$store);

  @Provide('WrittenOffSettingsResource')
  private writtenOffSettingsResource: WrittenOffSettingsResource =
    new WrittenOffSettingsResource(this.$store);

  @Provide('FiConfigurationResource')
  private fiConfigurationResource: FiConfigurationResource =
    new FiConfigurationResource(this.$store)

  @Provide('ReportResource')
  private reportResource: ReportResource =
    new ReportResource(this.$store)

  @Provide('CycleResource')
  private cycleResource: CycleResource =
    new CycleResource(this.$store)

  @Provide('ProductMappingResource')
  private productMappingResource: ProductMappingResource =
    new ProductMappingResource(this.$store)

  @Provide('ProductTypesResource')
  private productTypesResource: ProductTypesResource =
    new ProductTypesResource(this.$store)

  @Provide('AccountProductTypesResource')
  private accountProductTypesResource: AccountProductTypesResource =
    new AccountProductTypesResource(this.$store)

  @Provide('EngagementRewardResource')
  private engagementRewardResource: EngagementRewardResource =
    new EngagementRewardResource(this.$store)

  @Provide('KasasaUpgradeResource')
  private kasaasaUpgradeResource: KasasaUpgradeResource =
    new KasasaUpgradeResource(this.$store)

  drawer: boolean = true;

  showAccountStatusWarning: boolean = false;

  menuRefreshKey:boolean = false;

  productValidationErrors:boolean = false;

  mounted() {
    this.onNewRoute();
    this.currentMenuItems = [...this.initialMenuItems];
  }

  @Watch('$route')
  @Watch('auth', { deep: true })
  onNewRoute() {
    if (this.$route.name !== 'incomingredirect') {
      // Header data may not have been loaded yet, so hold off until it is so we can do clientId=>fiId lookup
      if (this.auth.headerData) {
        const clientId = this.$route.params.clientId;
        let fiId: string | null = null;
        if (clientId) {
          fiId = this.fiIdFromClientId(Number(clientId));
        }

        if (fiId && fiId !== this.fiId) {
          this.fetchAllConfigVersions(fiId);
        }

        const versionId: string | (string | null)[] = this.$route.query.version;
        if (fiId && fiId !== this.fiId && !versionId) {
          this.getCurrentConfigVersion(fiId);
        } else if (fiId && versionId) {
          this.getConfigVersion(fiId, versionId as string);
        }
      }
    }
  }

  fiIdFromClientId(clientId: number): string | null {
    let fiId: number | null = null;
    if (this.auth && this.auth.headerData) {
      for (let i: number = 0; i < this.auth.headerData.fis.length; i++) {
        // The linter insists on '===' here but that doesn't find a match. Not sure why.
        // Even defining fiId as number|null, the same as in the fi class, doesn't help.
        /* eslint-disable eqeqeq */
        if (this.auth.headerData.fis[i].id == clientId) {
          /* eslint-enable eqeqeq */
          fiId = this.auth.headerData.fis[i].fiId;
          break;
        }
      }
    }

    return fiId !== null ? fiId.toString() : null;
  }

  getCurrentConfigVersion(fiId: string) {
    let newVersion: ConfigVersion | null = null;
    this.configVersionResource.getCurrent(fiId).then((result: ConfigVersion) => {
      newVersion = result;
    }).catch((error: any) => {
      if (error.response.status !== 401) {
        this.showErrorMessage('An unexpected error occurred while attempting to '
          + 'retrieve the current configuration version.');
      }
    }).finally(() => {
      this.mutationFi(fiId);
      if (newVersion) {
        this.setNewConfigVersion(newVersion);
      }
    });
  }

  getConfigVersion(fiId: string, versionId: string) {
    let newVersion: ConfigVersion | null = null;
    this.configVersionResource.getOne(fiId, versionId).then((result: ConfigVersion) => {
      newVersion = result;
    }).catch((error: any) => {
      if (error.response.status !== 401) {
        this.showErrorMessage('An unexpected error occurred while attempting to '
          + `retrieve configuration version ${versionId}.  Defaulting to current version.`);
      }
    }).finally(() => {
      this.mutationFi(fiId);
      if (newVersion) {
        this.setNewConfigVersion(newVersion);
      } else {
        // Default to original
        this.getCurrentConfigVersion(fiId);
      }
    });
  }

  fetchAllConfigVersions(fiId: string) {
    this.configVersionResource.getAll(fiId).then((result: ConfigVersion[]) => {
      this.setNewAllConfigVersions(result);
    }).catch((error: any) => {
      if (error.response.status !== 401) {
        this.showErrorMessage('An unexpected error occurred while attempting to retrieve supported '
          + 'configuration versions.');
      }
    });
  }

  setNewConfigVersion(version: ConfigVersion) {
    this.mutationConfigVersion(version);
  }

  setNewAllConfigVersions(versions: ConfigVersion[]) {
    // sort in descending order by config start date
    const mutationConfigVersions = [...versions];
    mutationConfigVersions.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
    this.mutationAllConfigVersions(mutationConfigVersions);
  }

  @Watch('configVersion')
  onConfigVersionUpdation(version: ConfigVersion) {
    this.productResource.setVersionHeader(version.id);
    this.eocEmailEventResource.setVersionHeader(version.id);
    this.eocEmailConfigResource.setVersionHeader(version.id);
    this.sendEocEmailResource.setVersionHeader(version.id);
    this.atmSettingsResource.setDesignStartDate(version.startDate);
    this.interestSettingsResource.setVersionHeader(version.id);
    this.holidayResource.setVersionHeader(version.id);
    this.processingDaysResource.setVersionHeader(version.id);
    this.statmentCodeMappingRuleResource.setVersionHeader(version.id);
    this.accountTypeMappingRuleResource.setVersionHeader(version.id);
    this.relationshipClassificationRuleResource.setVersionHeader(version.id);
    this.transactionClassificationRuleResource.setVersionHeader(version.id);
    this.closedAccountResource.setVersionHeader(version.id);
    this.openedAccountResource.setVersionHeader(version.id);
    this.dormantAccountResource.setVersionHeader(version.id);
    this.loanAccountResource.setVersionHeader(version.id);
    this.delinquentSettingsResource.setVersionHeader(version.id);
    this.maturedSettingsResource.setVersionHeader(version.id);
    this.nonAccrualSettingsResource.setVersionHeader(version.id);
    this.writtenOffSettingsResource.setVersionHeader(version.id);
    this.fiConfigurationResource.setVersionHeader(version.id);
    this.productMappingResource.setVersionHeader(version.id);

    this.appTitle = `Rewards Configurations (${version.name})`;
  }

  @Watch('fiId')
  checkForUnmappedStatusCodeReport() {
    let showAccountStatusWarning = false;
    this.cycleResource.getActiveCycles(this.fiId).then((cycles:Cycle[]) => {
      if (cycles && cycles.length > 0) {
        this.reportResource.getReportInfos(this.fiId, cycles[0].id, 'CSV').then((reports:Report[]) => {
          reports.forEach((report:Report) => {
            if (report.filename.startsWith('kasasa_unmappedstatuscodes')) {
              showAccountStatusWarning = true;
            }
          });
        }).catch((error:any) => {
          this.showErrorMessage('Failed to check for unmapped status code report.');
        }).finally(() => {
          this.showAccountStatusWarning = showAccountStatusWarning;
        });
      }
    }).catch((error: any) => {
      this.showErrorMessage('Failed to get cycles.');
      this.showAccountStatusWarning = false;
    });
  }

  @Watch('fiId')
  checkForProductMappingErrorReport() {
    this.mutationProductMappingErrorMessage(null);

    this.productMappingResource.downloadErrorReport(parseInt(this.fiId, 10)).then((result:Blob) => {
      this.mutationProductMappingErrorMessage('Product Code/Account Type pair errors exist.');
    }).catch(() => {
      console.log('No product mapping error report found.');
    });
  }

  @Watch('fiId')
  validateProducts() {
    this.productValidationErrors = false;
    this.mutationProductValidationResults([]);
    this.productResource.getProductValidationsForCurrentVersion(this.fiId).then((results:ProductValidationResult[]) => {
      this.mutationProductValidationResults(results);

      this.productValidationErrors = false;
      for (let i = 0; i < results.length; i++) {
        this.productValidationErrors = ProductResource.productHasIssues(results[i]);
        if (this.productValidationErrors) {
          break;
        }
      }
    });
  }

  @Watch('fiId')
  @Watch('configVersion')
  findConfigVersions() {
    this.fetchAllConfigVersions(this.fiId);
  }

  @Watch('showAccountStatusWarning')
  @Watch('productMappingErrorMessage')
  @Watch('productValidationErrors')
  setMenuBarWarnings() {
      (this.initialMenuItems[0] as MenuItem).children!.forEach((item:MenuHeading|MenuItem) => {
        if (item && (item as MenuItem).to && ((item as MenuItem).to as any).name && ((item as MenuItem).to as any).name === 'accountstatussettings') {
          if (this.showAccountStatusWarning) {
            // Casting badge to "any" as a string is acceptable here and it has been updated in the latest version of fbase-components,
            // but updating to that caused a lot of unexpected dependency breakage.  After spending some time trying to unravel it,
            // decided just to roll-back and work around for now instead.
            // eslint-disable-next-line no-param-reassign
            ((item as MenuItem).badge as any) = '!';
          } else {
            // eslint-disable-next-line no-param-reassign
            (item as MenuItem).badge = undefined;
          }
        } else if (item && (item as MenuItem).to && ((item as MenuItem).to as any).name && ((item as MenuItem).to as any).name === 'productmappings') {
          if (this.productMappingErrorMessage) {
            // eslint-disable-next-line no-param-reassign
            ((item as MenuItem).badge as any) = '!';
          } else {
            // eslint-disable-next-line no-param-reassign
            (item as MenuItem).badge = undefined;
          }
        } else if (item && (item as MenuItem).to && ((item as MenuItem).to as any).name && ((item as MenuItem).to as any).name === 'products') {
          if (this.productValidationErrors) {
            // eslint-disable-next-line no-param-reassign
            ((item as MenuItem).badge as any) = '!';
          } else {
            // eslint-disable-next-line no-param-reassign
            (item as MenuItem).badge = undefined;
          }
        }
      });

      this.currentMenuItems = [...this.initialMenuItems];

      // Force menu to refresh
      this.menuRefreshKey = !this.menuRefreshKey;
  }
}
